export default __webpack_public_path__ + "static/media/up-sort.dc801cbc.svg";